export function clearElement( element: HTMLElement ): void {
    element.innerHTML = '';
}
